import { OFFLINE_MODE_ENABLED } from '../core/config.js';

const syncStatusEl = document.getElementById('sync-status');
const onlineStatusEl = document.getElementById('online-status');

if (!OFFLINE_MODE_ENABLED) {
    syncStatusEl.style.display = 'none';
}

const modalOfflinemodeOffEl = document.getElementById('modal-checkin-settings-offline-mode-off');
const modalOfflinemodeOnEl = document.getElementById('modal-checkin-settings-offline-mode-on');

if (modalOfflinemodeOffEl && modalOfflinemodeOnEl) {
    if (OFFLINE_MODE_ENABLED) {
        modalOfflinemodeOffEl.style.display = 'none';
        modalOfflinemodeOnEl.style.display = 'block';
    } else {
        modalOfflinemodeOffEl.style.display = 'block';
        modalOfflinemodeOnEl.style.display = 'none';
    }
}

export const UI = {
    setOnline() {
        if (!onlineStatusEl) return;
        onlineStatusEl.classList.add('online');
    },
    setOffline() {
        if (!onlineStatusEl) return;
        onlineStatusEl.classList.remove('online');
    },
    setInProgress() {
        if (!syncStatusEl) return;
        syncStatusEl.classList.add('in-progress');
    },
    renderSyncSummary(total, synced) {
        if (!syncStatusEl) return;

        syncStatusEl.classList.remove('in-progress');

        if (total && (total > 0) && (total == synced)) {
            syncStatusEl.classList.remove('unsynced');
            return
        } else if (total && (total != synced)) {
            syncStatusEl.classList.add('unsynced');
        } else {
            syncStatusEl.classList.add('unsynced');
        }
    },
};